PJQ.views.primeContracts.PrimeContractDataTable = PJQ.views.dataTables.DataTable.extend({
    defaults: {
        language: {
            emptyTable: 'No Contracts have been created yet',
            zeroRecords: "No Contracts matched the search criteria"
        },
        subTemplates: {
            header: new PJQ.templating.Template(PJQ.constants.modules.PRIMECONTRACTS, 'data-table-header-prime-contracts')
        },
        toggleRowClass: '.change-order-toggle-row'
    },
    events: {},
    beforeDataTableRender: function () {
        this.options.pageLength = this.options.settings ? this.options.settings.rowsPerPage : 10;
    },
    getDefaultFilter: function () {
        return _.size(this.options.statusIds) > 0 ? this.options.statusIds : this.options.userSettings.get('defaultPrimeContractStatusFilter');
    },
    afterHeaderRender: function () {
        new PJQ.inputs.Selectpicker({
            el: this.$('.prime-contracts-status-filter'),
            defaultValue: this.getDefaultFilter(),
            isIntChoices: true,
            isMultiple: true,
            noneSelectedText: 'No Filters',
            onChange: _.bind(function (value) {
                this.setFilter(PJQ.constants.primeContracts.filterType.PRIME_CONTRACT_STATUS_FILTER, value);
            }, this)
        });
        this.setFilter(PJQ.constants.primeContracts.filterType.PRIME_CONTRACT_STATUS_FILTER, this.getDefaultFilter());
    },
    getFilterData: function () {
        let statusFilter = this.getFilter(PJQ.constants.primeContracts.filterType.PRIME_CONTRACT_STATUS_FILTER);
        if (_.size(statusFilter) === 0) {
            return this.options.data;
        }

        return _.filter(this.options.data, function (row) {
            return (_.size(statusFilter) === 0 || _.contains(statusFilter, row.get('statusId')));
        });
    },
    getColumns: function (includeAllColumns = false) {
        this.options.canViewPrimeContracts = PJQ.app.session.project.hasPermission('primeContracts.canView');

        let columns = [],
            includeColumns = ['status', 'number', 'description', 'createdOn', 'startOn', 'estimatedCompleteOn', 'substantialCompleteOn', 'actualCompleteOn', 'contractOn', 'signedContractOn', 'executedOn', 'issuedOn', 'returnedOn', 'letterOfIntentOn', 'approvalLetterOn', 'contractTerminatedOn', 'inclusions', 'exclusions', 'isExecuted', 'amount', 'taxAmount', 'grandTotal', 'approvedChanges', 'contractTotal', 'progressAmount', 'amountRemaining'];

        if (this.options.customFields) {
            _.each(this.options.customFields.models, _.bind(function (customField) {
                includeColumns.push('fieldValue' + customField.get('fieldNumber'));
            }, this));
        }

        if (!includeAllColumns) {
            if (this.options.settings && _.size(this.options.settings.columns) > 0)
                includeColumns = this.options.settings.columns;
            else
                includeColumns = this.options.settings && this.options.settings.columnsDefault ? this.options.settings.columnsDefault : includeColumns;

            columns.push({
                "columnData": "childData",
                "data": null,
                "title": "",
                "width": "20px",
                "orderable": false,
                "searchable": false,
                "defaultContent": '',
                "render": (data, type, row) => {
                    if (!this.options.isAdmin) {
                        return "";
                    }

                    return PJQ.helpers.erp.getERPIcon(row.erpSyncStatus());
                }
            });
        }

        _.each(includeColumns, _.bind(function (columnName) {
            switch (columnName) {
                case 'status':
                    columns.push({
                        "columnData": "status",
                        "data": "attributes.statusId",
                        "title": "Status",
                        "width": "100px",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.constants.primeContracts.primeContractStatusNames[row.get('statusId')]
                        }, this)
                    });
                    break;
                case 'number':
                    columns.push({
                        "columnData": "number",
                        "data": "attributes.number",
                        "title": "Number",
                        "render": _.bind(function (data, type, row) {
                            if (type === 'sort' || type === 'type') {
                                return row.get('number');
                            }
                            return '<a href="javascript:void(0)" class="btn-view-prime-contract">' + data + '</a>'
                        }, this)
                    });
                    break;
                case 'description':
                    columns.push({
                        "columnData": "description",
                        "data": "attributes.description",
                        "title": "Description"
                    });
                    break;
                case 'createdOn':
                    columns.push({
                        "columnData": "createdOn",
                        "data": "attributes.createdOn",
                        "title": 'Created',
                        "width": '90px',
                        "render": _.bind(function (data, type, row) {
                            if (_.size(data) === 0) {
                                return '';
                            } else if (type === 'sort' || type === 'type') {
                                return data ? new Date(data) : null;
                            }
                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME);
                        }, this)
                    });
                    break;
                case 'startOn':
                    columns.push({
                        "columnData": "startOn",
                        "data": "attributes.startOn",
                        "title": 'Start',
                        "width": '90px',
                        "render": _.bind(function (data, type, row) {
                            if (_.size(data) === 0) {
                                return '';
                            } else if (type === 'sort' || type === 'type') {
                                return data ? new Date(data) : null;
                            }
                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                        }, this)
                    });
                    break;
                case 'estimatedCompleteOn':
                    columns.push({
                        "columnData": "estimatedCompleteOn",
                        "data": "attributes.estimatedCompleteOn",
                        "title": 'Est. Complete',
                        "width": '90px',
                        "render": _.bind(function (data, type, row) {
                            if (_.size(data) === 0) {
                                return '';
                            } else if (type === 'sort' || type === 'type') {
                                return data ? new Date(data) : null;
                            }
                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                        }, this)
                    });
                    break;
                case 'substantialCompleteOn':
                    columns.push({
                        "columnData": "substantialCompleteOn",
                        "data": "attributes.substantialCompleteOn",
                        "title": 'Substantial Complete',
                        "width": '90px',
                        "render": _.bind(function (data, type, row) {
                            if (_.size(data) === 0) {
                                return '';
                            } else if (type === 'sort' || type === 'type') {
                                return data ? new Date(data) : null;
                            }
                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                        }, this)
                    });
                    break;
                case 'actualCompleteOn':
                    columns.push({
                        "columnData": "actualCompleteOn",
                        "data": "attributes.actualCompleteOn",
                        "title": 'Act. Complete',
                        "width": '90px',
                        "render": _.bind(function (data, type, row) {
                            if (_.size(data) === 0) {
                                return '';
                            } else if (type === 'sort' || type === 'type') {
                                return data ? new Date(data) : null;
                            }
                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                        }, this)
                    });
                    break;
                case 'contractOn':
                    columns.push({
                        "columnData": "contractOn",
                        "data": "attributes.contractOn",
                        "title": 'Contract Date',
                        "width": '90px',
                        "render": _.bind(function (data, type, row) {
                            if (_.size(data) === 0) {
                                return '';
                            } else if (type === 'sort' || type === 'type') {
                                return data ? new Date(data) : null;
                            }
                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                        }, this)
                    });
                    break;
                case 'signedContractOn':
                    columns.push({
                        "columnData": "signedContractOn",
                        "data": "attributes.signedContractOn",
                        "title": 'Signed Date',
                        "width": '90px',
                        "render": _.bind(function (data, type, row) {
                            if (_.size(data) === 0) {
                                return '';
                            } else if (type === 'sort' || type === 'type') {
                                return data ? new Date(data) : null;
                            }
                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                        }, this)
                    });
                    break;
                case 'executedOn':
                    columns.push({
                        "columnData": "executedOn",
                        "data": "attributes.executedOn",
                        "title": 'Execution Date',
                        "width": '90px',
                        "render": _.bind(function (data, type, row) {
                            if (_.size(data) === 0) {
                                return '';
                            } else if (type === 'sort' || type === 'type') {
                                return data ? new Date(data) : null;
                            }
                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                        }, this)
                    });
                    break;
                case 'issuedOn':
                    columns.push({
                        "columnData": "issuedOn",
                        "data": "attributes.issuedOn",
                        "title": 'Issued On',
                        "width": '90px',
                        "render": _.bind(function (data, type, row) {
                            if (_.size(data) === 0) {
                                return '';
                            } else if (type === 'sort' || type === 'type') {
                                return data ? new Date(data) : null;
                            }
                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                        }, this)
                    });
                    break;
                case 'returnedOn':
                    columns.push({
                        "columnData": "returnedOn",
                        "data": "attributes.returnedOn",
                        "title": 'Returned On',
                        "width": '90px',
                        "render": _.bind(function (data, type, row) {
                            if (_.size(data) === 0) {
                                return '';
                            } else if (type === 'sort' || type === 'type') {
                                return data ? new Date(data) : null;
                            }
                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                        }, this)
                    });
                    break;
                case 'letterOfIntentOn':
                    columns.push({
                        "columnData": "letterOfIntentOn",
                        "data": "attributes.letterOfIntentOn",
                        "title": 'Letter of Intent',
                        "width": '90px',
                        "render": _.bind(function (data, type, row) {
                            if (_.size(data) === 0) {
                                return '';
                            } else if (type === 'sort' || type === 'type') {
                                return data ? new Date(data) : null;
                            }
                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                        }, this)
                    });
                    break;
                case 'approvalLetterOn':
                    columns.push({
                        "columnData": "approvalLetterOn",
                        "data": "attributes.approvalLetterOn",
                        "title": 'Approval Letter',
                        "width": '90px',
                        "render": _.bind(function (data, type, row) {
                            if (_.size(data) === 0) {
                                return '';
                            } else if (type === 'sort' || type === 'type') {
                                return data ? new Date(data) : null;
                            }
                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                        }, this)
                    });
                    break;
                case 'contractTerminatedOn':
                    columns.push({
                        "columnData": "contractTerminatedOn",
                        "data": "attributes.contractTerminatedOn",
                        "title": 'Termination Date',
                        "width": '90px',
                        "render": _.bind(function (data, type, row) {
                            if (_.size(data) === 0) {
                                return '';
                            } else if (type === 'sort' || type === 'type') {
                                return data ? new Date(data) : null;
                            }
                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                        }, this)
                    });
                    break;
                case 'inclusions':
                    columns.push({
                        "columnData": "inclusions",
                        "data": "attributes.inclusions",
                        "title": "Inclusions"
                    });
                    break;
                case 'exclusions':
                    columns.push({
                        "columnData": "exclusions",
                        "data": "attributes.exclusions",
                        "title": "Exclusions"
                    });
                    break;
                case 'isExecuted':
                    columns.push({
                        "columnData": "isExecuted",
                        "data": "attributes.isExecuted",
                        "title": "Executed"
                    });
                    break;
                case 'amount':
                    columns.push({
                        "columnData": "amount",
                        "data": "attributes.amount",
                        "title": "Amount",
                        "width": "100px",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.formatHelpers.formatCurrency(data);
                        }, this)
                    });
                    break;
                case 'taxAmount':
                    columns.push({
                        "columnData": "taxAmount",
                        "data": "attributes.taxAmount",
                        "title": "Tax",
                        "width": "100px",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.formatHelpers.formatCurrency(data);
                        }, this)
                    });
                    break;
                case 'originalContract':
                    columns.push({
                        "columnData": "originalContract",
                        "data": "attributes.amount",
                        "title": "Contract Total",
                        "width": "100px",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.formatHelpers.formatCurrency(row.getGrandTotal());
                        }, this)
                    });
                    break;
                case 'approvedChanges':
                    columns.push({
                        "columnData": "approvedChanges",
                        "data": "attributes.approvedChanges",
                        "width": "100px",
                        "title": "Approved Changes",
                        "className": "text-align-right",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.formatHelpers.formatCurrency(row.get('approvedChanges'));
                        }, this)
                    });
                    break;
                case 'contractTotal':
                    columns.push({
                        "columnData": "contractTotal",
                        "data": "attributes.amount",
                        "width": "100px",
                        "title": "Contract Total",
                        "className": "text-align-right",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.formatHelpers.formatCurrency(row.getGrandTotal() + row.get('approvedChanges'));
                        }, this)
                    });
                    break;
                case 'progressAmount':
                    columns.push({
                        "columnData": "progressAmount",
                        "data": "attributes.progressAmount",
                        "width": "100px",
                        "title": "Billed to Date",
                        "className": "text-align-right",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.formatHelpers.formatCurrency(row.get('progressAmount') + row.get('progressTaxAmount') - row.get('retainageAmount') + row.get('retainageReleasedAmount'));
                        }, this)
                    });
                    break;
                case 'amountRemaining':
                    columns.push({
                        "columnData": "amountRemaining",
                        "data": "attributes.amountRemaining",
                        "width": "100px",
                        "title": "Amount Remaining",
                        "className": "text-align-right",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.formatHelpers.formatCurrency(row.get('amount') + row.get('approvedChanges') - row.get('progressAmount'));
                        }, this)
                    });
                    break;
                default:
                    if (columnName.startsWith('fieldValue')) {
                        _.each(this.customFields.models, function (customField) {
                            if (columnName === 'fieldValue' + customField.get('fieldNumber')) {
                                columns.push({
                                    "columnData": 'fieldValue' + customField.get('fieldNumber'),
                                    "title": customField.get('name'),
                                    "render": function (data, type, row) {
                                        let fieldValue = row.getCustomFieldValue(customField.get('id'));
                                        fieldValue = (fieldValue !== null) ? fieldValue : '';
                                        switch (customField.get('fieldTypeId')) {
                                            case PJQ.constants.commitments.customFieldType.BOOLEAN:
                                                if (fieldValue != null)
                                                    fieldValue = fieldValue ? 'Yes' : 'No';
                                                break;
                                            case PJQ.constants.commitments.customFieldType.CHOICE:
                                                let choices = [];
                                                // convert single choice value into array so that the logic below can work for both types.
                                                if (typeof fieldValue === 'number')
                                                    fieldValue = [fieldValue];

                                                _.each(customField.choices.models, _.bind(function (choice) {
                                                    if (_.find(fieldValue, function (value) {
                                                        return value === choice.get('id');
                                                    }))
                                                        choices.push(choice.get('name'));
                                                }, this));

                                                fieldValue = choices.join((', '));
                                                break;
                                            case PJQ.constants.commitments.customFieldType.DATE:
                                                if (fieldValue) {
                                                    if (type !== 'sort' && type !== 'type')
                                                        fieldValue = PJQ.helpers.dateHelpers.getDateString(new Date(fieldValue), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                                                }
                                                if (fieldValue === undefined)
                                                    fieldValue = '';

                                                break;
                                            case PJQ.constants.commitments.customFieldType.DATETIME:
                                                if (fieldValue) {
                                                    if (type !== 'sort' && type !== 'type')
                                                        fieldValue = PJQ.helpers.dateHelpers.getDateString(new Date(fieldValue), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME);
                                                }
                                                if (fieldValue === undefined)
                                                    fieldValue = '';

                                                break;
                                            case PJQ.constants.commitments.customFieldType.INTEGER:
                                                if (type !== 'sort' && type !== 'type' && fieldValue) {
                                                    fieldValue = parseInt(fieldValue).toLocaleString();
                                                }
                                                break;
                                            case PJQ.constants.commitments.customFieldType.MONEY:
                                                if (type === 'sort' || type === 'type') {
                                                    if (fieldValue && fieldValue !== '$')
                                                        fieldValue = parseFloat(PJQ.helpers.formatHelpers.numbersOnly(fieldValue, true));
                                                    else
                                                        fieldValue = 0;
                                                } else {
                                                    fieldValue = PJQ.helpers.formatHelpers.formatCurrency(parseInt(PJQ.helpers.formatHelpers.numbersOnly(fieldValue)));
                                                }
                                                break;
                                            case PJQ.constants.commitments.customFieldType.PERCENT:
                                                if (type === 'sort' || type === 'type') {
                                                    if (fieldValue && fieldValue !== '$')
                                                        fieldValue = parseFloat(PJQ.helpers.formatHelpers.numbersOnly(fieldValue / 100, true)).toFixed(2)
                                                    else
                                                        fieldValue = 0;
                                                } else {
                                                    fieldValue = fieldValue ? parseFloat(PJQ.helpers.formatHelpers.numbersOnly(fieldValue / 100, true)).toFixed(2) + '%' : '';
                                                }

                                                break;
                                        }
                                        return fieldValue;
                                    }
                                });
                            }
                        });
                    }
                    break;
            }
        }, this));

        if (!includeAllColumns) {
            columns.push({
                "title": '',
                "render": _.bind(function (data, type, row) {
                    let html = '<div class="show-on-row-hover">',
                        status = row.get('statusId');
                    if (this.options.canViewPrimeContracts) {
                        html += '<button type="button" class="btn btn-info btn-view-prime-contract ml-1" title="View contract"><i class="fal fa-arrow-alt-from-left"></i></button>';
                    }
                    if (status !== PJQ.constants.primeContracts.primeContractStatus.TERMINATED) {
                        // html += '<button type="button" class="btn btn-success btn-add-change-order ml-1" title="New Change Order"><i class="fal fa-arrow-right-arrow-left"></i></button>';
                    }
                    html += '</div>'
                    return html
                }, this),
                "orderable": false,
                "searchable": false,
                "width": "90px",
                "className": "text-center",
                "visible": true
            });
        }

        return columns;
    },
    getRowChildTable: function (childOpts) {
        childOpts.parentDataTable = this;
        childOpts.dom = 't';
        return new PJQ.views.commitments.LineItemDataTable(childOpts);
    },
    getRowChildData: function (row) {
        return new PJQ.collections.primeContracts.LineItems(null, {
            primeContractId: row.data().id
        });
    }
});